import React from 'react';
import {Redirect} from "react-router";

export default function NoMatch() {
    return (<Redirect to={{pathname: '/login'}}/>)
}